export default __webpack_public_path__ + "static/media/solargo.9204b38e.png";